module.exports = __webpack_public_path__ + "static/media/icon-menu-close.431aebdc.svg";